import { createApp } from 'vue';
import Rw2ToPngConverter from '../Components/Rw2ToPngConverter.vue';

const root = document.getElementById('rw2-to-png-converter');
if (root) {
  createApp(Rw2ToPngConverter).mount('#rw2-to-png-converter');
}
